// Словарь производства (подпроект 5): проекты, этапы, задачи, Гант, загрузка, автоподбор. Подключается в `ru.ts`
// одной строкой, чтобы не мешать соседним разделам.

/** Интерфейс производства: раздел «Проекты», проект, задачи, Гант, загрузка. */
export const ruProjects = {
  title: 'Проекты',
  hint: 'Работа студии после продажи: этапы, задачи, сроки и загрузка команды. Проект появляется сам, когда клиент подписал заявку; можно завести и вручную',
  hintExample:
    'Сделка «Сайт пекарни» выиграна — появился проект с этапами и задачами из сметы, сроки разложены по рабочим дням',
  newProject: 'Новый проект',
  saveFailed: 'Не удалось сохранить — попробуйте ещё раз',
  loadFailed: 'Не удалось загрузить проект',
  more: 'Ещё',
  views: { label: 'Вид раздела', list: 'Список', gantt: 'Гант', load: 'Загрузка' },
  filters: {
    scope: 'Чьи проекты',
    mine: 'Мои',
    all: 'Все',
    kind: 'Вид',
    status: 'Состояние',
    archived: 'Архив',
    reset: 'Сбросить фильтры',
  },
  kinds: { fixed: 'Под ключ', tm: 'Почасовой', subscription: 'Подписка' },
  statuses: {
    planning: 'Планирование',
    active: 'В работе',
    paused: 'На паузе',
    delivering: 'Сдаётся',
    done: 'Сдан',
  },
  urgencies: { deferred: 'Отложенный', optimal: 'Оптимальный', urgent: 'Срочный' },
  risks: { clear: 'Всё продумано', concept: 'Есть концепция', idea: 'Только идея' },
  taskStatuses: { queue: 'Очередь', in_progress: 'В работе', review: 'На проверке', done: 'Готово' },
  waitingReasons: { client: 'Ждёт клиента', task: 'Ждёт другую задачу', other: 'Ждёт другого' },
  complexities: { '1': 'Простая', '2': 'Обычная', '3': 'Сложная' },
  workDays: {
    one: '{count} раб. день',
    few: '{count} раб. дня',
    many: '{count} раб. дней',
    other: '{count} раб. дня',
  },
  projectsCount: {
    one: '{count} проект',
    few: '{count} проекта',
    many: '{count} проектов',
    other: '{count} проекта',
  },
  noClient: 'Внутренний',
  noDue: 'Срок не задан',
  atRisk: 'Под угрозой срыва',
  late: 'Позже договора на {days}',
  archivedBadge: 'В архиве',
  unassignedCount: 'Без исполнителя: {count}',
  columns: {
    project: 'Проект',
    lead: 'Руководитель',
    stages: 'Этапы',
    due: 'Срок',
    urgency: 'Срочность',
  },
  stagesProgress: '{done} из {total}',
  plannedEnd: 'План: {date}',
  list: {
    emptyTitle: 'Проектов пока нет',
    emptyText:
      'Проект появится сам, когда клиент подпишет заявку. Можно завести и вручную — внутренний или для старого клиента',
    emptyMineTitle: 'У вас пока нет проектов',
    emptyMineText: 'Здесь будут проекты, где вы руководитель, участник или исполнитель задачи',
    emptyFilteredTitle: 'Ничего не нашлось',
    emptyFilteredText: 'Под эти фильтры проектов нет — сбросьте их',
    emptyArchiveTitle: 'Архив пуст',
    emptyArchiveText: 'Сюда попадают сданные и отложенные проекты: данные и часы в них сохраняются',
  },
  create: {
    title: 'Новый проект',
    lead: 'Проект без сделки: внутренняя работа студии или старый клиент. Этапы и задачи добавите в самом проекте',
    name: 'Название',
    namePlaceholder: 'Например, «Сайт пекарни»',
    client: 'Клиент',
    clientPlaceholder: 'Без клиента — внутренний проект',
    kind: 'Вид',
    leadField: 'Руководитель',
    leadPlaceholder: 'Вы',
    due: 'Срок по договору',
    submit: 'Создать проект',
    created: 'Проект «{title}» создан',
  },
  hints: {
    kinds: {
      title: 'Виды проектов',
      text: 'Под ключ — работа по договору с этапами и итоговым актом. Почасовой — оплата по подтверждённым часам. Подписка — сопровождение: часы начисляются каждый месяц',
      example: 'Сайт за 450 000 ₽ — под ключ; доработки по 2 500 ₽/ч — почасовой',
    },
    status: {
      title: 'Состояние проекта',
      text: 'Планирование — проект собран, идёт назначение исполнителей. В работе — задачи делаются. На паузе — работа приостановлена. Сдаётся — итоговый акт у клиента',
      example: 'Назначили всех исполнителей — «Начать работу»',
    },
    risk: {
      title: 'Риск срыва',
      text: 'Задача под угрозой, если её срок прошёл, а она не готова, или если оставшиеся часы не помещаются в свободное время исполнителя до срока. Этап — если под угрозой хоть одна задача; проект — если этап или план позже срока по договору',
      example: 'Осталось 16 ч, а у дизайнера до пятницы свободно 10 ч — задача под угрозой',
    },
    urgency: {
      title: 'Срочность и риск',
      text: 'Срочность — насколько важно успеть к сроку. Риск — насколько продумана работа: от «Всё продумано» до «Только идея»',
      example: 'Сайт к открытию кафе — «Срочный», макеты согласованы — «Всё продумано»',
    },
    late: {
      title: 'Позже договора',
      text: 'План проекта — окончание последней задачи. Если он позже срока по договору, это предупреждение: новый срок с клиентом согласуют допсоглашением',
      example: 'Срок по договору 15.11, последняя задача кончается 20.11 — «Позже договора на 3 раб. дня»',
    },
    assign: {
      title: 'Автоподбор исполнителя',
      text: 'Кандидаты — сотрудники с нужной специализацией. Скорость — как человек обычно укладывается в план по прошлым задачам (меньше 3 задач — «мало истории», считаем 1,0). Сначала те, кому ожидаемые часы помещаются в свободное время с учётом отпусков, потом по ожидаемой стоимости',
      example: 'Обычно +20% к плану: 10 ч по плану ≈ 12 ч; свободно 30 ч до 15.10',
    },
    load: {
      title: 'Ёмкость и загрузка',
      text: 'Ёмкость — часы на проекты в неделю (недельная ёмкость × доля на проекты) за вычетом выходных и отпусков. Загрузка — плановые часы незакрытых задач, разложенные по рабочим дням задачи. Больше ёмкости — перегруз',
      example: 'Ёмкость 32 ч, задач на 40 ч — ячейка красная',
    },
    waiting: {
      title: 'Ждёт',
      text: 'Отметка поверх статуса: задача не пропадает с доски, но видно, чего она ждёт — клиента, другой задачи или чего-то ещё',
      example: 'Ждёт клиента: тексты для главной',
    },
    extraScope: {
      title: 'Сверх договора',
      text: 'Работа, которой нет в договоре. Отмеченные задачи потом одной кнопкой собираются в допсоглашение; без отметки часы идут за счёт студии',
      example: 'Клиент попросил ещё и английскую версию сайта',
    },
    links: {
      title: 'Связь «после»',
      text: 'Задача начинается после другой. Сдвинете ту — эта сдвинется на столько же рабочих дней',
      example: '«Вёрстка» после «Дизайна главной»',
    },
  },
  path: {
    label: 'Путь проекта',
    contract: 'Договор',
    stages: 'Этапы',
    delivery: 'Сдача',
    subscription: 'Подписка',
    assignAll: 'Назначьте исполнителей',
    start: 'Начать работу',
    addTasks: 'Добавьте задачи',
    contractDeal: 'Сделка «{title}»',
    contractManual: 'Заведён вручную',
    stagesDone: 'Закрыто {done} из {total}',
    deliveryLater: 'Сдача проекта появится в следующей части',
    subscriptionNone: 'Не подключена',
    subscriptionPending: 'Начнётся {date}',
    subscriptionActive: 'Действует с {date}',
    subscriptionPaused: 'На паузе',
    subscriptionEnded: 'Закончилась {date}',
    subscriptionNoTerms: 'Условия не заданы — вкладка «Часы»',
    subscriptionOpen: 'Открыть подписку',
    next: 'Следующий шаг',
    nextAddTasks: 'В проекте нет задач — добавьте этапы и задачи на вкладке «Задачи»',
    nextAssign: 'Задач без исполнителя: {count} — подберём по специализации и свободному времени',
    nextStart: 'Задачи и исполнители готовы — переведите проект в работу',
    nextCloseStage: 'Этап «{title}»: готово {done} из {total} задач',
    nextDeliver: 'Все этапы закрыты — пора сдавать проект',
    closeStageShort: 'Закрыть этап',
  },
  toast: {
    assigned: 'Подобраны исполнители: {count}',
    assignedSkipped: 'Подобраны исполнители: {count}; без кандидатов: {skipped}',
    nothingToAssign: 'Все задачи уже с исполнителями',
    shifted: 'Сроки сдвинуты',
    moved: 'Сроки задачи изменены',
    archived: 'Проект «{title}» в архиве',
    restored: 'Проект «{title}» возвращён',
    deleted: 'Проект «{title}» удалён',
    taskDeleted: 'Задача «{title}» удалена',
    stageDeleted: 'Этап «{title}» удалён',
    memberRemoved: '{name} больше не участник',
    started: 'Работа над проектом началась',
  },
  menu: {
    shift: 'Сдвинуть проект…',
    start: 'Начать работу',
    pause: 'Поставить на паузу',
    resume: 'Продолжить',
    archive: 'В архив',
    unarchive: 'Вернуть из архива',
    delete: 'Удалить проект',
  },
  card: {
    tabTasks: 'Задачи',
    tabGantt: 'Сроки',
    tabTz: 'ТЗ',
    tabChat: 'Чат',
    tabHistory: 'История',
    tabAbout: 'О проекте',
    activity: 'Лента проекта',
    chatEmptyTitle: 'Обсуждение проекта',
    chatEmptyText: 'Здесь пишут руководитель и участники: вопросы, решения, файлы',
    chatLead: 'Общий чат команды проекта. Вопросы по одной задаче — в её обсуждении: откройте задачу',
    historyLead: 'Кто и что менял в проекте: задачи, сроки, исполнители',
    sectionProject: 'Проект',
    sectionPeople: 'Люди',
    fieldTitle: 'Название',
    fieldClient: 'Клиент',
    fieldKind: 'Вид',
    fieldUrgency: 'Срочность',
    fieldRisk: 'Риск',
    fieldDue: 'Срок по договору',
    fieldStarts: 'Начало',
    fieldPlannedEnd: 'Окончание по плану',
    fieldLead: 'Руководитель',
    fieldMembers: 'Участники',
    addMember: 'Добавить',
    addMemberPlaceholder: 'Кого добавить',
    removeMember: 'Убрать {name} из участников',
    archivedNotice: 'Проект в архиве: он не виден в рабочих списках, править его нельзя.',
    pausedNotice: 'Проект на паузе.',
    notFound: 'Проект не найден',
    notFoundText: 'Его удалили, или у вас нет к нему доступа',
    backToList: 'Проекты',
  },
  stages: {
    noStage: 'Без этапа',
    add: 'Этап',
    addPlaceholder: 'Название этапа, например «Дизайн»',
    rename: 'Переименовать',
    clientTitle: 'Название для клиента',
    remove: 'Удалить этап',
    moveUp: 'Выше',
    moveDown: 'Ниже',
    progress: '{done} из {total} · {hours}',
    dates: '{from} — {to}',
  },
  tasks: {
    emptyTitle: 'Задач пока нет',
    emptyText: 'Добавьте этап и задачи — или они придут сами из сметы, когда проект создаётся по сделке',
    emptyMemberText: 'Задачи добавляет руководитель проекта',
    add: 'Задача',
    addPlaceholder: 'Новая задача — Enter',
    addSpecialization: 'Специализация',
    noAssignee: 'Нет исполнителя',
    noDates: 'Без дат',
    groupBy: 'Группировка',
    view: 'Вид',
    viewList: 'Список',
    viewBoard: 'Доска',
    addStageOpen: 'Добавить этап',
    addTaskOpen: 'Добавить задачу',
    byStage: 'По этапам',
    byAssignee: 'По исполнителям',
    statusMenu: 'Статус задачи «{title}»',
    overdue: 'Просрочена',
    extraScope: 'Сверх договора',
    columnTask: 'Задача',
    columnAssignee: 'Исполнитель',
    columnDates: 'Сроки',
    columnPlan: 'План',
    columnStatus: 'Статус',
    open: 'Открыть задачу «{title}»',
  },
  task: {
    panelTitle: 'Задача',
    title: 'Название',
    status: 'Статус',
    assignee: 'Исполнитель',
    assigneePlaceholder: 'Выберите исполнителя',
    suggest: 'Подобрать',
    suggestTitle: 'Кого назначить',
    suggestLead: 'Порядок: сначала те, кому задача помещается в свободное время, потом дешевле',
    suggestEmpty: 'Нет сотрудников с этой специализацией — добавьте её кому-нибудь в «Команде»',
    assign: 'Назначить',
    current: 'Назначен',
    fits: 'Успевает',
    noFit: 'Не успевает',
    speedNormal: 'укладывается в план',
    speedFaster: 'обычно −{percent}% к плану',
    speedSlower: 'обычно +{percent}% к плану',
    lowHistory: 'мало истории',
    expected: '≈ {hours}',
    free: 'свободно {hours}',
    absence: '{kind} {from}–{to}',
    dates: 'Сроки',
    startsOn: 'Начало',
    endsOn: 'Окончание',
    stage: 'Этап',
    specialization: 'Специализация',
    complexity: 'Сложность',
    planned: 'План, часы',
    waiting: 'Ждёт',
    waitingNone: 'Не ждёт',
    waitingNote: 'Чего ждёт',
    waitingNotePlaceholder: 'Например, тексты для главной',
    extraScope: 'Сверх договора',
    description: 'Описание',
    descriptionPlaceholder: 'Что сделать, ссылки, критерии готовности',
    acceptance: 'Критерии приёмки',
    acceptanceHint:
      'Критерии из ТЗ проекта — по ним клиент принимает работу. Править — на вкладке «ТЗ»; свои критерии задачи пишите в описании',
    links: 'После задач',
    addLink: 'Добавить связь',
    addLinkPlaceholder: 'После какой задачи',
    removeLink: 'Убрать связь с «{title}»',
    noLinks: 'Нет связей',
    remove: 'Удалить задачу',
    notFound: 'Задачи нет — возможно, её удалили',
    timeLater: 'Таймер, записи времени и обсуждение задачи появятся в следующей части',
  },
  gantt: {
    emptyTitle: 'На Ганте пока пусто',
    emptyText:
      'Задайте задачам сроки — или нажмите «Назначьте исполнителей», сроки у задач из сметы уже есть',
    noDatesTitle: 'Без дат: {count}',
    today: 'Сегодня',
    due: 'Срок по договору',
    bar: 'Задача «{title}»: {from} — {to}',
    moveStart: 'Сдвинуть начало «{title}»',
    moveEnd: 'Сдвинуть окончание «{title}»',
    loadTitle: 'Загрузка исполнителей по неделям',
    loadHint:
      'Часы незакрытых задач человека за неделю по всем проектам против его ёмкости: «26 из 32». Красное — перегруз, штриховка — отпуск или отгул',
    keyboard: 'Стрелки — сдвиг на рабочий день, Shift — на неделю',
    zoom: 'Масштаб',
    zoomDays: 'Дни',
    zoomWeeks: 'Недели',
    lead: 'Задачи по дням, сгруппированы по этапам. Ниже — сколько часов у каждого исполнителя в неделю',
    loadSection: 'Загрузка команды',
  },
  shift: {
    title: 'Сдвинуть проект',
    lead: 'Все незакрытые задачи сдвинутся на столько рабочих дней; готовые останутся на месте. Исполнители не меняются',
    days: 'На сколько рабочих дней',
    daysHint: 'Минус — раньше: −3 сдвинет на три рабочих дня назад',
    preview: 'Задач сдвинется: {count}',
    previewEnd: 'План: {from} → {to}',
    nothing: 'Сдвигать нечего: у незакрытых задач нет дат',
    submit: 'Сдвинуть',
  },
  portfolio: {
    emptyTitle: 'Портфель пуст',
    emptyText: 'Здесь будут проекты полосами этапов по времени',
    noDates: 'Нет дат',
  },
  load: {
    emptyTitle: 'Загрузку смотреть не на ком',
    emptyText: 'Добавьте сотрудникам ёмкость в «Команде» — и здесь появится загрузка по неделям',
    person: 'Сотрудник',
    week: 'Неделя с {date}',
    cell: '{load} из {capacity}',
    absent: 'Отсутствует дней: {days}',
    previous: 'Раньше',
    next: 'Позже',
    thisWeek: 'Эта неделя',
    tasksTitle: '{name}: задачи на неделе с {date}',
    tasksEmpty: 'На эту неделю задач нет',
    inRange: '{hours} на неделе',
  },
  absences: {
    tab: 'Отпуска',
    lead: 'Отпуска, больничные и отгулы: в эти дни сотрудник не подбирается в задачи, его ёмкость — ноль',
    ownLead: 'Ваши отпуска, больничные и отгулы. Добавляет и правит их администратор',
    add: 'Добавить',
    empty: 'Отсутствий нет',
    kinds: { vacation: 'Отпуск', sick: 'Больничный', day_off: 'Отгул' },
    kind: 'Вид',
    dates: 'Даты',
    note: 'Заметка',
    notePlaceholder: 'Например, «Море»',
    dialogAdd: 'Новое отсутствие',
    dialogEdit: 'Отсутствие',
    save: 'Сохранить',
    edit: 'Изменить',
    remove: 'Удалить',
    removed: 'Отсутствие удалено',
    range: '{from} — {to}',
    current: 'Сейчас',
  },
  palette: {
    newProject: 'Новый проект',
    keywords: 'проект производство задачи гант',
    group: 'Проекты',
  },
  chatLabel: 'Проект',
  notifications: {
    createdTitle: 'Новый проект «{title}»',
    createdBody: 'Назначьте исполнителей: откройте проект и нажмите «Подобрать всем»',
    assignedTitle: 'Вам назначена задача «{title}»',
    assignedBody: 'Проект «{project}»',
    unassignedTitle: 'Задача «{title}» снята с вас',
  },
} as const;

/** Тексты ошибок `projects.*` (раздел 11 спецификации подпроекта 5). */
export const ruProjectsErrors = {
  not_lead: 'Это может сделать только руководитель проекта',
  lead_not_allowed: 'Руководителем может быть только действующий сотрудник с правом вести проекты',
  transition_invalid: 'Задачу нельзя перевести из «{from}» в «{to}»',
  link_cycle: 'Связь создаёт круг: задача ждала бы сама себя',
  link_other_project: 'Связать можно только задачи одного проекта',
  dates_invalid: 'Начало задачи позже её окончания',
  delete_has_history: 'В проекте есть подтверждённые часы или документы — его можно только отправить в архив',
  no_specialist: 'Нет сотрудников со специализацией «{name}» — добавьте её кому-нибудь в «Команде»',
  title_required: 'Назовите проект — например, «Сайт пекарни»',
  title_too_long: 'Название длиннее {max} знаков — сократите',
  stage_title_required: 'Назовите этап — например, «Дизайн»',
  stage_not_empty: 'В этапе есть задачи — перенесите или удалите их, потом удаляйте этап',
  stages_too_many: 'В проекте не больше {max} этапов',
  tasks_too_many: 'В проекте не больше {max} задач — разбейте его на несколько',
  tz_too_long: 'ТЗ слишком длинное — сократите его или вынесите подробности в задачи',
  task_title_invalid: 'Назовите задачу (до 200 знаков)',
  task_minutes_invalid: 'Плановые часы — от 0 до 1000',
  task_complexity_invalid: 'Сложность — 1, 2 или 3',
  waiting_note_invalid: 'Напишите, чего ждёт задача (до 300 знаков)',
  assignee_inactive: 'Исполнителем может быть только действующий сотрудник',
  specialization_unknown: 'Такой специализации нет — выберите из списка',
  archived: 'Проект в архиве — верните его, чтобы менять',
  client_not_found: 'Клиент не найден — возможно, его удалили',
  member_is_lead: 'Руководителя не убрать из участников — сначала смените руководителя',
  member_has_tasks: 'У человека есть открытые задачи проекта — переназначьте их, потом убирайте',
  range_invalid: 'Выберите период: начало не позже конца, не больше полугода',
  shift_invalid: 'Сдвиг — от −250 до 250 рабочих дней, не ноль',
} as const;

/** «История» проекта и подписи журнала. */
export const ruProjectsAudit = {
  actions: {
    project: {
      created: 'Создан проект',
      created_from_deal: 'Проект создан из выигранной сделки',
      changed: 'Изменён проект',
      lead_changed: 'Сменился руководитель',
      status_changed: 'Изменено состояние проекта',
      archived: 'Проект в архиве',
      restored: 'Проект возвращён из архива',
      deleted: 'Проект удалён',
      undeleted: 'Удаление проекта отменено',
      member_added: 'Добавлен участник',
      member_removed: 'Участник убран',
      stage_added: 'Добавлен этап',
      stage_changed: 'Изменён этап',
      stage_removed: 'Удалён этап',
      stages_reordered: 'Этапы переставлены',
      task_added: 'Добавлена задача',
      tasks_drafted: 'Добавлены задачи из черновика ИИ',
      tz_changed: 'Изменено ТЗ',
      task_changed: 'Изменена задача',
      task_removed: 'Удалена задача',
      task_moved: 'Задача перенесена',
      task_assigned: 'Назначен исполнитель',
      tasks_assigned: 'Исполнители подобраны',
      task_status_changed: 'Изменён статус задачи',
      link_added: 'Добавлена связь «после»',
      link_removed: 'Убрана связь «после»',
      dates_changed: 'Изменены сроки задач',
      shifted: 'Проект сдвинут',
    },
  },
  entities: {
    project: 'Проект',
  },
  fields: {
    urgency: 'Срочность',
    risk: 'Риск',
    dueOn: 'Срок по договору',
    lead: 'Руководитель',
    startsOn: 'Начало',
    endsOn: 'Окончание',
    plannedMinutes: 'План, часы',
    complexity: 'Сложность',
    waiting: 'Ждёт',
    extraScope: 'Сверх договора',
    shiftDays: 'Сдвиг, рабочих дней',
    projectKind: 'Вид проекта',
    projectStatus: 'Состояние проекта',
    taskStatus: 'Статус задачи',
    tasksAdded: 'Задач добавлено',
  },
} as const;
